import { createSlice } from "@reduxjs/toolkit";
import {
  getAllJobLevels,
  createJobLevel,
  updateJobLevel,
  deleteJobLevel,
  getAllJobGroups,
  createJobGroup,
  updateJobGroup,
  deleteJobGroup,
  getAllDepartments,
  createDepartment,
  updateDepartment,
  deleteDepartment,
} from "./Thunk";

export const organization = createSlice({
  name: "organization",
  initialState: {
    // JobLevel state
    jobLevelId: "",
    jobLevelName: "",
    jobLevelDescription: "",
    jobLevelList: [],
    isJobLevelUpdateOperation: false,

    // JobGroup state
    jobGroupId: "",
    jobGroupName: "",
    jobGroupDescription: "",
    jobGroupList: [],
    isJobGroupUpdateOperation: false,

    // Department state
    departmentId: "",
    departmentName: "",
    departmentDescription: "",
    departmentList: [],
    isDepartmentUpdateOperation: false,

    // General state
    isLoading: false,
  },
  reducers: {
    // JobLevel reducers
    UpdateJobLevelName(state, action) {
      state.jobLevelName = action.payload;
    },
    UpdateJobLevelDescription(state, action) {
      state.jobLevelDescription = action.payload;
    },
    UpdateJobLevelState(state, action) {
      state.isJobLevelUpdateOperation = action.payload.isUpdateOperation;
      state.jobLevelName = action.payload.name;
      state.jobLevelDescription = action.payload.description;
      state.jobLevelId = action.payload.id;
    },
    ClearJobLevelState(state) {
      state.isJobLevelUpdateOperation = false;
      state.jobLevelName = "";
      state.jobLevelDescription = "";
      state.jobLevelId = "";
    },

    // JobGroup reducers
    UpdateJobGroupName(state, action) {
      state.jobGroupName = action.payload;
    },
    UpdateJobGroupDescription(state, action) {
      state.jobGroupDescription = action.payload;
    },
    UpdateJobGroupState(state, action) {
      state.isJobGroupUpdateOperation = action.payload.isUpdateOperation;
      state.jobGroupName = action.payload.name;
      state.jobGroupDescription = action.payload.description;
      state.jobGroupId = action.payload.id;
    },
    ClearJobGroupState(state) {
      state.isJobGroupUpdateOperation = false;
      state.jobGroupName = "";
      state.jobGroupDescription = "";
      state.jobGroupId = "";
    },

    // Department reducers
    UpdateDepartmentName(state, action) {
      state.departmentName = action.payload;
    },
    UpdateDepartmentDescription(state, action) {
      state.departmentDescription = action.payload;
    },
    UpdateDepartmentState(state, action) {
      state.isDepartmentUpdateOperation = action.payload.isUpdateOperation;
      state.departmentName = action.payload.name;
      state.departmentDescription = action.payload.description;
      state.departmentId = action.payload.id;
    },
    ClearDepartmentState(state) {
      state.isDepartmentUpdateOperation = false;
      state.departmentName = "";
      state.departmentDescription = "";
      state.departmentId = "";
    },
  },
  extraReducers: (builder) => {
    // JobLevel extra reducers
    builder.addCase(getAllJobLevels.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllJobLevels.fulfilled, (state, action) => {
      state.jobLevelList = action.payload;
      state.isLoading = false;
    });
    builder.addCase(createJobLevel.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createJobLevel.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateJobLevel.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateJobLevel.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(deleteJobLevel.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteJobLevel.fulfilled, (state) => {
      state.isLoading = false;
    });

    // JobGroup extra reducers
    builder.addCase(getAllJobGroups.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllJobGroups.fulfilled, (state, action) => {
      state.jobGroupList = action.payload;
      state.isLoading = false;
    });
    builder.addCase(createJobGroup.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createJobGroup.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateJobGroup.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateJobGroup.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(deleteJobGroup.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteJobGroup.fulfilled, (state) => {
      state.isLoading = false;
    });

    // Department extra reducers
    builder.addCase(getAllDepartments.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllDepartments.fulfilled, (state, action) => {
      state.departmentList = action.payload;
      state.isLoading = false;
    });
    builder.addCase(createDepartment.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createDepartment.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateDepartment.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateDepartment.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(deleteDepartment.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteDepartment.fulfilled, (state) => {
      state.isLoading = false;
    });
  },
});

export const {
  UpdateJobLevelName,
  UpdateJobLevelDescription,
  UpdateJobLevelState,
  ClearJobLevelState,
  UpdateJobGroupName,
  UpdateJobGroupDescription,
  UpdateJobGroupState,
  ClearJobGroupState,
  UpdateDepartmentName,
  UpdateDepartmentDescription,
  UpdateDepartmentState,
  ClearDepartmentState,
} = organization.actions;

export default organization.reducer;
